import React, { FC } from "react";
import clsx from "clsx";
import { HtagProps } from "./Htag.props";

const Htag: FC<HtagProps> = React.memo(
	({
		tag: Tag,
		type = "regular",
		children,
		className = "",
		onClick,
		dangerouslySetInnerHTML,
		...props
	}): JSX.Element => {
		const baseClassNames = clsx(
			{
				h1: "minPhone:text-h3 lg:text-h1 leading-[120%]",
				h2: "minPhone:text-h3 lg:text-h2 leading-normal",
				h3: "minPhone:text-h4 lg:text-h3 leading-normal",
				h4: "minPhone:text-h5 lg:text-h4 leading-normal",
				h5: "minPhone:text-h6 lg:text-h5 leading-normal",
				h6: "minPhone:text-h6 lg:text-h6 leading-normal",
				body: "text-body leading-normal",
				caption: "text-caption leading-normal",
				small: "text-small leading-normal",
			}[Tag],
			{
				"font-light": type === "light",
				"font-normal": type === "regular",
				"font-medium": type === "medium",
				"font-semibold": type === "semibold",
				"font-bold": type === "bold",
				"font-extrabold": type === "extrabold",
			},

			"cursor-default font-Montserrat",
			className,
		);

		return (
			<Tag
				className={baseClassNames}
				onClick={onClick}
				{...(dangerouslySetInnerHTML ? { dangerouslySetInnerHTML } : {})}
				{...props}
			>
				{!dangerouslySetInnerHTML && children}
			</Tag>
		);
	},
);

export default Htag;
